{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "",
    "{amount} off": "",
    "{amount} off for first {number} months.": "",
    "{amount} off for first {period}.": "",
    "{amount} off forever.": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% rabato",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "",
    "{memberEmail} will no longer receive this newsletter.": "",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} tagoj senpagaj",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konto",
    "Account details updated successfully": "",
    "Account settings": "Kontagordoj",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Post senpaga provo finiĝos, vi pagos la regulan prezon por la nivelo, kiun vi elektis. Vi ĉiam povas nuligi antaŭ tiam.",
    "Already a member?": "Ĉu membro jam?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "",
    "Back": "Reen",
    "Back to Log in": "Reen al Ensaluto",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "",
    "Cancel subscription": "Nuligu abonon",
    "Canceled": "",
    "Cancellation reason": "Nuliga kialo",
    "Change": "",
    "Change plan": "",
    "Check spam & promotions folders": "",
    "Check with your mail provider": "",
    "Check your inbox to verify email update": "",
    "Choose": "",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Elektu alian planon",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose an option": "",
    "Choose your newsletters": "Elektu viajn bultenojn",
    "City": "",
    "Click here to retry": "",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Fermu",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentoj",
    "Complimentary": "",
    "Confirm": "Konfirmu",
    "Confirm cancellation": "",
    "Confirm subscription": "",
    "Contact support": "",
    "Continue": "Daŭrigu",
    "Continue subscription": "",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "",
    "Could not update email! Invalid link.": "",
    "Country": "",
    "Create a new contact": "",
    "Current plan": "",
    "Delete account": "Forigu konton",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "",
    "Don't have an account?": "Ĉu ne havas konton?",
    "Edit": "",
    "Email": "Retadreso",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "",
    "Email newsletter settings updated": "",
    "Email preferences": "Retpoŝtaj agordoj",
    "Email preferences updated.": "",
    "Emails": "Retpoŝtoj",
    "Emails disabled": "Retpoŝtoj malŝaltitaj",
    "Ends {offerEndDate}": "",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "",
    "Expires {expiryDate}": "",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "",
    "Free Trial – Ends {trialEnd}": "",
    "From": "",
    "Get help": "Ricevi helpon",
    "Get in touch for help": "",
    "Get notified when someone replies to your comment": "Estu sciiga kiam iu respondos al via komento",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Donu komentojn pri ĉi tiu afiŝo",
    "Help! I'm not receiving emails": "",
    "Here are a few other sites you may enjoy.": "",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Sendis ensalutan ligilon al via enirkesto. Se ĝi ne alvenas post 3 minutoj, nepre kontrolu vian trudmesaĝdosieron.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Malpli tiel",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "",
    "Manage": "Administru",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "",
    "Monthly": "Monate",
    "More like this": "Pli kiel ĉi tio",
    "More options": "",
    "Name": "Nomo",
    "Need more help? Contact support": "",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "",
    "No member exists with this e-mail address.": "",
    "No options found": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "",
    "Now": "",
    "Now check your email!": "Bonvolu kontroli vian retpoŝton nun!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "",
    "Phone number": "",
    "Plan": "",
    "Plan checkout was cancelled.": "",
    "Plan upgrade was cancelled.": "",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Reŝalti retpoŝtojn",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Remove {option}": "",
    "Renews at {price}.": "",
    "Resume subscription": "",
    "Retry": "Reprovu",
    "Save": "Konservi",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Sendanta ensaluta ligilo...",
    "Sending...": "Sendante...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "",
    "Sign in": "Ensalutu",
    "Sign out": "",
    "Sign up": "Aliĝu",
    "Signup error: Invalid link": "",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "",
    "Spam complaints": "",
    "Start {amount}-day free trial": "Komencu senpaga {amount}-taga provo",
    "Starting {startDate}": "",
    "Starting today": "",
    "State": "",
    "Submit feedback": "Sendu rimarkojn",
    "Subscribe": "",
    "Subscribed": "",
    "Subscription plan updated successfully": "",
    "Success": "",
    "Success! Check your email for magic link to sign-in.": "",
    "Success! Your account is fully activated, you now have access to all content.": "",
    "Success! Your email is updated.": "",
    "Successfully unsubscribed": "Sukcese malabonita",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Dankon pro la rimarkoj!",
    "That didn't go to plan": "Tio ne iris laŭ la intenco",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "",
    "There was a problem submitting your feedback. Please try again a little later.": "",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Ĉi tiu retejo estas nur por invitiĝuloj, kontaktu la proprietulo por alireblo.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Por kompletigi aliĝon, premu la konfirman ligilon en via enirkesto. Se ĝi ne alvenas ene de 3 minutoj, kontrolu vian trudmesaĝdosieron!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "",
    "Unable to initiate checkout session": "",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "",
    "Unsubscribe from all emails": "Malabonu de ĉiuj retpoŝtoj",
    "Unsubscribed": "",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Malabonigi de retpoŝtoj ne nuligos vian pagitan abonon al {title}",
    "Update": "",
    "Update your preferences": "Ĝisdatigu viajn agordojn",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "",
    "Verifying...": "",
    "View plans": "",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ni ne povis malaboni vin ĉar la retadreso ne estis trovita. Bonvolu kontakti la proprietulo de la retejo",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "",
    "Welcome back!": "",
    "Welcome to {siteTitle}": "",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "",
    "Why has my email been disabled?": "",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Jare",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "",
    "You have been successfully resubscribed": "Vi sukcese reaboniĝis",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "",
    "You're not receiving emails": "",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Vi ne ricevas retpoŝtojn ĉar vi aŭ markis lastatempan mesaĝon kiel trudmesaĝo, aŭ ĉar mesaĝoj ne povis liveri al via provizita retadreso.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Via konto",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Via enigo helpas formi kio estas aperigita.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "",
    "Your subscription will renew on {renewalDate}": "",
    "Your subscription will start on {subscriptionStart}": ""
}
